<template>
  <div class="card">
    <div>
      <h1 class="f5 f4-l fw5 ma0 pa0 lh-title text-primary">
        {{ header.title.main }}
        <span v-if="header.title.secondary" class="db f6 f5-l ma0 pa0 lh-title text-secondary">
          {{ header.title.secondary }}
        </span>
      </h1>
    </div>

    <div class="mt4 mb5">
      <div class="tl">
        <span class="f4 f3-ns fw5">{{ header.current.label }}</span>
        <span class="text-secondary f6 ml2">{{ header.current.unit }}</span>
      </div>
      <div class="f6 mt1 text-secondary w-auto">
        {{ header.percent.value }}{{ header.percent.unit }}
        от max
        {{ header.total.label }} {{ header.total.unit }}
      </div>
      <div class="w4">
      </div>
    </div>

    <svg-base-plot :config="data.plotConfig">
      <svg-plot-line :data="data.series" />
    </svg-base-plot>

  </div>
</template>

<script>
import SvgBasePlot from '@/components/charts/svg/plot/Plot.vue'
import SvgPlotLine from '@/components/charts/svg/plot/Line.vue'
import { colors } from '@/plugins/colors.js'

export default {
  components: {
    SvgBasePlot,
    SvgPlotLine
  },
  props: ['data'],
  computed: {
    header () {
      return {
        title: {
          section: 'Усредненные показатели',
          main: this.data.header,
          secondary: this.data.subheader
        },
        current: {
          value: this.average.count,
          label: this.average.count.toLocaleString('ru-RU'),
          unit: this.data.unit
        },
        total: {
          value: this.average.max,
          label: this.average.max.toLocaleString('ru-RU'),
          unit: this.data.unit
        },
        percent: {
          value: this.average.percent.toFixed(2),
          label: this.average.percent.toFixed(2),
          unit: '%'
        }
      }
    },
    average () {
      return this.data ? this.data.average : { count: 0, max: 0 }
    },
    progress () {
      return {
        legend: {
          progress: 'Среднее',
          total: 'Максимальное'
        },
        style: {
          color: {
            progress: colors[2],
            total: colors[0]
          },
          font: {
            size: '0.4'
          }
        },
        format: {
          value: (value) => { return value.toLocaleString('ru-RU') }
        },
        data: [
          { progress: { value: this.data.average.count }, total: { value: this.data.average.max } }
        ]
      }
    }
  }
}
</script>
